module.exports = {
          srcSet: __webpack_public_path__ + "6f56e70542005cccb02ac955721b88c2-11.png"+" 11w",
          images:[ {path: __webpack_public_path__ + "6f56e70542005cccb02ac955721b88c2-11.png",width: 11,height: 10}],
          src: __webpack_public_path__ + "6f56e70542005cccb02ac955721b88c2-11.png",
          toString:function(){return __webpack_public_path__ + "6f56e70542005cccb02ac955721b88c2-11.png"},
          
          width: 11,
          height: 10
        }